<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
      Network: "Rede",
      Sponsored: "Indicados",
      Username: "Usuário",
      Name: "Nome",
      Date: "Data",
      "E-mail": "E-mail",
      Cellphone: "Celular",
      Plan: "Plano",
      Status: "Status",
      Qualified: "Qualificado",
      Unqualified: "Não Qualificado",
      Left: "Esquerdo",
      Right: "Direito",
      Pending: "Pendente",
      Approved: "Aprovado",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.",
      "No records found.": "Nenhum registro encontrado.",
      Graduation: "Graduação",
      Binary: "Binário",
      "Total Referred": "Total de Indicados",
      ACTIVE: "ATIVO",
      INACTIVE: "INATIVO",
      "Spillover Side": "Lado de Derramamento",
      "Choose a side": "Escolha um lado",
      "Left Side": "Lado Esquerdo",
      "Right Side": "Lado Direito",
      "Smaller Side": "Lado Menor",
      Save: "Salvar",
      "The spillover side has been successfully changed!": "O lado de derramamento foi alterado com sucesso!",
      "The user entered is invalid.": "O usuário informado é inválido.",
      "The side entered is invalid.": "O lado informado é inválido.",
      Country: "País",
      All: "Todos",
      "Products Vertical": "Vertical de Produtos",
      "Services Vertical": "Vertical de Serviços",
      "All from Vertical": "Todos da Vertical",
      Products: "Produtos",
      Services: "Serviços",
      "minimum 3 characters": "mínimo 3 caracteres",
      "Send message on WhatsApp": "Enviar mensagem no WhatsApp",
      months: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    },
    es: {
      Network: "Red",
      Sponsored: "Patrocinados",
      Username: "Nombre de Usuario",
      Name: "Nombre",
      Date: "Fecha",
      "E-mail": "Correo Electrónico",
      Cellphone: "Celular",
      Plan: "Plan",
      Status: "Estado",
      Qualified: "Calificado",
      Unqualified: "No Cualificado",
      Left: "Izquierdo",
      Right: "Derecho",
      Pending: "Pendiente",
      Approved: "Aprobado",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtalo de nuevo más tarde.",
      "No records found.": "No se encontraron registros.",
      Graduation: "Graduación",
      Binary: "Binario",
      "Total Referred": "Total de Referidos",
      ACTIVE: "ACTIVO",
      INACTIVE: "INACTIVO",
      "Spillover Side": "Lado de Desbordamiento",
      "Choose a side": "Elige un lado",
      "Left Side": "Lado Izquierdo",
      "Right Side": "Lado Derecho",
      "Smaller Side": "Lado Menor",
      Save: "Guardar",
      "The spillover side has been successfully changed!": "¡El lado de desbordamiento ha sido cambiado con éxito!",
      "The user entered is invalid.": "El usuario ingresado no es válido.",
      "The side entered is invalid.": "El lado ingresado no es válido.",
      Country: "País",
      All: "Todos",
      "Products Vertical": "Vertical de Productos",
      "Services Vertical": "Vertical de Servicios",
      "All from Vertical": "Todos de la Vertical",
      Products: "Productos",
      Services: "Servicios",
      "minimum 3 characters": "mínimo 3 caracteres",
      "Send message on WhatsApp": "Enviar mensaje por WhatsApp",
      months: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    },
  },
  components: {
    Layout,
    Stat,
  },
  data() {
    return {
      table: {
        body: null,
        loading: true,
      },

      filters: {
        country: "",
        username: "",
        name: "",
        plan: "",
        graduation: "",
        monthly: "",
        binary: "",
      },
      options: {
        countries: [],
        plans: [],
        graduations: [],
      },
      searchTimer: null,

      statData: null,

      binary: {
        modal: false,
        loading: false,
        id: "",
        name: "",
        side: "",
      },
    };
  },
  computed: {
    // Colunas da tabela. Computed para os rotulos acompanharem o idioma
    fields() {
      return [
        { key: "country", label: "" },
        { key: "avatar", label: "" },
        { key: "username", label: this.t("Username"), tdClass: "notranslate" },
        { key: "date", label: this.t("Date"), tdClass: "notranslate" },
        { key: "cellphone", label: this.t("Cellphone"), tdClass: "notranslate" },
        { key: "package", label: this.t("Plan") },
        { key: "graduation", label: this.t("Graduation") },
        { key: "monthly_products", label: this.t("Products") },
        { key: "monthly_services", label: this.t("Services") },
        { key: "binary", label: this.t("Binary") },
      ];
    },
    // Rotulo do que esta selecionado em cada dropdown
    selected() {
      const country = this.options.countries.find(
        (item) => item.abbr === this.filters.country
      );
      const plan = this.options.plans.find(
        (item) => item.id === this.filters.plan
      );
      const graduation = this.options.graduations.find(
        (item) => item.id === this.filters.graduation
      );
      const active = this.t("ACTIVE").toLowerCase();
      const inactive = this.t("INACTIVE").toLowerCase();
      const status = {
        products_active: this.t("Products Vertical") + " - " + active,
        products_inactive: this.t("Products Vertical") + " - " + inactive,
        services_active: this.t("Services Vertical") + " - " + active,
        services_inactive: this.t("Services Vertical") + " - " + inactive,
        all_active: this.t("All from Vertical") + " - " + active,
        all_inactive: this.t("All from Vertical") + " - " + inactive,
      };
      const sides = {
        l: this.t("Left Side"),
        r: this.t("Right Side"),
      };

      return {
        country: country ? country.name : this.t("All"),
        username: this.filters.username
          ? this.filters.username.toUpperCase()
          : this.t("All"),
        name: this.filters.name ? this.filters.name : this.t("All"),
        plan: plan ? plan.name : this.t("All"),
        graduation: graduation ? graduation.name : this.t("All"),
        monthly: status[this.filters.monthly] || this.t("All"),
        binary: sides[this.filters.binary] || this.t("All"),
      };
    },
  },
  methods: {
    // Os campos de texto so filtram a partir de 3 caracteres
    getTextQuery(value) {
      return value && value.trim().length >= 3 ? value.trim() : "";
    },
    getSponsoreds() {
      this.table.body = null;

      const params = new URLSearchParams();

      const query = {
        country: this.filters.country,
        username: this.getTextQuery(this.filters.username),
        name: this.getTextQuery(this.filters.name),
        plan: this.filters.plan,
        graduation: this.filters.graduation,
        monthly: this.filters.monthly,
        binary: this.filters.binary,
      };

      Object.keys(query).forEach((key) => {
        if (query[key] !== "" && query[key] !== null) {
          params.append(key, query[key]);
        }
      });

      api
        .get("network/sponsored?" + params.toString())
        .then((response) => {
          if (response.data.status == "success") {
            this.table.body = response.data.list;

            this.statData = [
              {
                type: "line",
                icon: "bx bx-user",
                title: "Total Referred",
                value: response.data.total,
              },
            ];

            if (response.data.filters) {
              this.options.countries = response.data.filters.countries || [];
              this.options.plans = response.data.filters.plans || [];
              this.options.graduations = response.data.filters.graduations || [];
            }
          }
        })
        .catch(() => {
          this.table.body = [];
        })
    },
    // Campos de texto so disparam depois que o usuario para de digitar
    getSponsoredsDebounced() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getSponsoreds();
      }, 500);
    },
    changeBinarySide(row) {
      this.binary.id = row.binary.id;
      this.binary.name = row.name;
      this.binary.side = row.binary.side;

      this.binary.modal = false;
      this.binary.modal = true;
      this.binary.loading = false;
    },
    saveBinarySide() {
      this.binary.loading = true;

      api
        .post('network/binary/side', {
          id: this.binary.id,
          side: this.binary.side
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.binary.modal = false;
            this.binary.loading = false;
            this.$toast.success(this.t('The spillover side has been successfully changed!'))
            this.getSponsoreds();
          } else {
            this.binary.modal = false;
            this.binary.loading = false;

            this.$toast.error(this.t(response.data.message))
          }
        })
        .finally(() => {
          this.binary.loading = false;
        })
    }
  },
  mounted() {
    this.getSponsoreds();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  watch: {
    "filters.country": function () {
      this.getSponsoreds();
    },
    "filters.plan": function () {
      this.getSponsoreds();
    },
    "filters.graduation": function () {
      this.getSponsoreds();
    },
    "filters.monthly": function () {
      this.getSponsoreds();
    },
    "filters.binary": function () {
      this.getSponsoreds();
    },
    // Ignora digitacao que continua abaixo do minimo de 3 caracteres
    "filters.username": function (value, old) {
      if (this.getTextQuery(value) !== this.getTextQuery(old)) {
        this.getSponsoredsDebounced();
      }
    },
    "filters.name": function (value, old) {
      if (this.getTextQuery(value) !== this.getTextQuery(old)) {
        this.getSponsoredsDebounced();
      }
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">{{ t('Network') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Sponsored') }}</h3>
        <p></p>
      </div>
    </div>

    <div id="dropdown" class="d-flex flex-wrap mb-4 filters-grid">
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Country') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.country }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.country" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="country in options.countries" :key="country.abbr">
          <b-form-radio v-model="filters.country" :value="country.abbr">{{ country.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Username') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.username }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form @submit.prevent>
          <b-form-input v-model="filters.username" autocomplete="off"></b-form-input>
          <small class="text-muted">{{ t('minimum 3 characters') }}</small>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Name') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.name }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form @submit.prevent>
          <b-form-input v-model="filters.name" autocomplete="off"></b-form-input>
          <small class="text-muted">{{ t('minimum 3 characters') }}</small>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Plan') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.plan }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.plan" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="plan in options.plans" :key="plan.id">
          <b-form-radio v-model="filters.plan" :value="plan.id">{{ plan.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Graduation') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.graduation }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.graduation" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="graduation in options.graduations" :key="graduation.id">
          <b-form-radio v-model="filters.graduation" :value="graduation.id">{{ graduation.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Status') }}</h6>
              <div class="font-size-12 text-muted text-capitalize">{{ selected.monthly.toLowerCase() }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.monthly" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <template v-for="group in [{ key: 'products', label: 'Products Vertical' }, { key: 'services', label: 'Services Vertical' }, { key: 'all', label: 'All from Vertical' }]">
          <b-dropdown-header :key="group.key + '-header'">{{ t(group.label) }}</b-dropdown-header>
          <b-dropdown-form :key="group.key + '-active'">
            <b-form-radio v-model="filters.monthly" :value="group.key + '_active'" class="text-capitalize">{{ t('ACTIVE').toLowerCase() }}</b-form-radio>
          </b-dropdown-form>
          <b-dropdown-form :key="group.key + '-inactive'">
            <b-form-radio v-model="filters.monthly" :value="group.key + '_inactive'" class="text-capitalize">{{ t('INACTIVE').toLowerCase() }}</b-form-radio>
          </b-dropdown-form>
        </template>
      </b-dropdown>

      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0">{{ t('Binary') }}</h6>
              <div class="font-size-12 text-muted">{{ selected.binary }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filters.binary" value="">{{ t('All') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form>
          <b-form-radio v-model="filters.binary" value="l">{{ t('Left Side') }}</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form>
          <b-form-radio v-model="filters.binary" value="r">{{ t('Right Side') }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div v-if="!table.body" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="table.body && table.body.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          {{ t('No records found.') }}
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <b-table :items="table.body" :fields="fields" class="table-nowrap table-style table-hover" head-variant="light" responsive>
            <template #cell(country)="row">
              <img v-if="row.value" :src="'https://kapowaz.github.io/circle-flags/flags/' + row.value + '.svg'" :alt="row.value.toUpperCase()" :title="row.value.toUpperCase()" width="24" />
            </template>
            <template #cell(avatar)="row">
              <img v-if="row.value" class="rounded-circle header-profile-user" :src="row.value" alt="" style="width: 40px; height: 40px" />
              <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=2C00F5&color=fff&name=' + row.item.name" alt="" style="width: 40px; height: 40px" />
            </template>
            <template #cell(username)="row">
              <span class="font-size-12">{{ row.value }}</span><br>
              {{ row.item.name }}
            </template>
            <template #cell(cellphone)="row">
              {{ row.value }}
              <a v-if="row.value" class="btn btn-success btn-sm ml-2 p-0 px-1" target="_blank" rel="noopener" :href="'https://wa.me/' + row.value.replace(/[^0-9]/g, '')" :title="t('Send message on WhatsApp')">
                <i class="bx bxl-whatsapp align-middle"></i>
              </a>
            </template>
            <template #cell(package)="row">
              <span class="badge badge-soft-dark font-size-12">{{ row.value }}</span>
            </template>
            <template #cell(monthly_products)="row">
              <span v-if="row.item.monthly.products === 'inactive'" class="badge badge-soft-danger font-size-12">{{ t('INACTIVE') }}</span>
              <span v-else-if="row.item.monthly.products === 'active'" class="badge badge-soft-success font-size-12">{{ t('ACTIVE') }}</span>
            </template>
            <template #cell(monthly_services)="row">
              <span v-if="row.item.monthly.services === 'inactive'" class="badge badge-soft-danger font-size-12">{{ t('INACTIVE') }}</span>
              <span v-else-if="row.item.monthly.services === 'active'" class="badge badge-soft-success font-size-12">{{ t('ACTIVE') }}</span>
            </template>
            <template #cell(graduation)="row">
              <img v-if="row.value.image" class="rounded-circle header-profile-user" :src="require('@/assets/images/graduations/' + row.value.image)" alt="" style="width: 40px; height: 40px" />
              <img v-else class="rounded-circle header-profile-user" src="@/assets/images/logo-icon-app.png" alt="" style="width: 40px; height: 40px" />
              <span class="badge font-size-12">{{ row.value.name }}</span>
            </template>
            <template #cell(binary)="row">
              <span v-if="row.value.side === 'l'" class="font-size-12">{{ t('Left') }}</span>
              <span v-else-if="row.value.side === 'r'" class="font-size-12">{{ t('Right') }}</span>
              –
              <span v-if="row.value.status === 'inactive'" class="badge badge-soft-warning font-size-12">{{ t('INACTIVE') }}</span>
              <span v-else-if="row.value.status === 'active'" class="badge badge-soft-success font-size-12">{{ t('ACTIVE') }}</span>
              <button v-if="row.value.status == 'inactive'" class="border-0 bg-white" v-on:click="changeBinarySide(row.item)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                  <path
                    d="M19.924 10.383a1 1 0 0 0-.217-1.09l-5-5-1.414 1.414L16.586 9H4v2h15a1 1 0 0 0 .924-.617zM4.076 13.617a1 1 0 0 0 .217 1.09l5 5 1.414-1.414L7.414 15H20v-2H5a.999.999 0 0 0-.924.617z">
                  </path>
                </svg>
              </button>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <b-modal v-model="binary.modal" :title="t('Spillover Side')" modal-class="modal-right" hide-footer>
      <b-form @submit.prevent="saveBinarySide()">
        <h4 class="mb-4">
          {{ binary.name }}
        </h4>
        <b-form-group :label="t('Choose a side')" label-for="binary.side">
          <select v-model="binary.side" class="custom-select mb-2">
            <option value="l">{{ t('Left Side') }}</option>
            <option value="r">{{ t('Right Side') }}</option>
            <option value="m">{{ t('Smaller Side') }}</option>
          </select>
        </b-form-group>
        <b-button class="mb-0" :disabled="this.binary.loading" type="submit" variant="default" size="lg">
          {{ t('Save') }}
          <b-spinner v-if="binary.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
        </b-button>
      </b-form>
    </b-modal>
  </Layout>
</template>

<style>
/* Barra de filtros. Sem `scoped` porque o .dropdown-toggle vem do b-dropdown,
   que nao recebe o atributo de escopo desta pagina.
   O gap de 10px vem do #dropdown global e entra nos calc() abaixo. */
#dropdown.filters-grid {
  flex-wrap: wrap;
  /* O pai (.d-lg-flex, junto do card de total) e flex: sem crescer aqui,
     a barra encolhe ao conteudo e os filtros nao tem espaco para esticar */
  flex: 1 1 auto;
  min-width: 0;
}

/* Desktop: os filtros dividem a linha inteira em partes iguais */
#dropdown.filters-grid > .b-dropdown {
  flex: 1 1 0;
  min-width: 0;
}

#dropdown.filters-grid .dropdown-toggle {
  width: 100%;
}

/* O conteudo do botao precisa ocupar a largura toda para o chevron
   encostar na direita */
#dropdown.filters-grid .dropdown-toggle > div {
  width: 100%;
}

/* Com os botoes estreitos, o valor selecionado nao pode empurrar o chevron */
#dropdown.filters-grid .dropdown-toggle .text-left {
  min-width: 0;
}

#dropdown.filters-grid .dropdown-toggle .text-left > * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Tablet: ate 4 por linha (3 gaps de 10px divididos entre as 4 colunas) */
@media (max-width: 1025px) {
  #dropdown.filters-grid > .b-dropdown {
    flex: 0 0 calc(25% - 7.5px);
  }
}

/* Mobile: 2 por linha. O #dropdown global empilha um por linha aqui,
   por isso a direcao volta para row */
@media (max-width: 576px) {
  #dropdown.filters-grid {
    flex-direction: row;
  }

  #dropdown.filters-grid > .b-dropdown {
    flex: 0 0 calc(50% - 5px);
  }

  #dropdown.filters-grid .dropdown-toggle {
    padding-left: 14px;
  }

  #dropdown.filters-grid .dropdown-menu {
    min-width: 100%;
  }
}
</style>
